import * as THREE from 'three';

import SlideMesh from './_mesh';


export default class Stage{

    constructor(textures){
        this.textures = textures;

        this.$canvas = document.getElementById('js-slide-canvas');
        this.$srcs = [...document.querySelectorAll('.js-slide-targets img')];
        
        this.scene = null;
        this.renderer = null;
        this.camera = null;
        this.img = null;
        this.isRaf = true;

        this.csize = this._getCanvasSize();
        
        this._init();
    }


    swipeAction(vect){
        if(!this.img) return;

        if(vect==='prev') this.img.prev();
        else this.img.next();

        // キャンバスのサイズをセット
        this._getCanvasSize();
        this.resize();
    }


    change(index){
        if(!this.img) return;
        this.img.change(index);

        // キャンバスのサイズをセット
        this._getCanvasSize();
        this.resize();
    }


    resize(){
        this.csize = this._getCanvasSize();

        this.camera.left = -this.csize.w / 2;
        this.camera.right = this.csize.w / 2;
        this.camera.top = this.csize.h / 2;
        this.camera.bottom = -this.csize.h / 2;;
        this.camera.updateProjectionMatrix();

        this.renderer.setSize(this.csize.w, this.csize.h);
        this.img.resize();
        this.renderer.render(this.scene, this.camera);
    }


    _init(){
        this.scene = new THREE.Scene();
        this._setRenderer();
        this._setCamera();
        this._setMesh();
        this._update();
    }


    _setRenderer(){
        this.renderer = new THREE.WebGLRenderer({
            canvas:this.$canvas, 
            antialias: false, 
            alpha: true
        });
        
        const ratio = Math.min(2, window.devicePixelRatio);
        this.renderer.setPixelRatio(ratio);

        this.renderer.setSize(this.csize.w, this.csize.h);
    }


    _setCamera(){
        this.camera = new THREE.OrthographicCamera(-this.csize.w/2, this.csize.w/2, this.csize.h/2, -this.csize.h/2, 0.1, 1000);
        this.camera.position.z = 1;
    }


    _setMesh(){
        this.img = new SlideMesh(this.textures);
        this.scene.add(this.img.mesh);
    }


    _update(){
        this.renderer.render(this.scene, this.camera);
        if(this.isRaf) requestAnimationFrame(this._update.bind(this));
    }


    _getCanvasSize(){
        let index = 0;
        if(this.img) index = this.img.nowIndex - 1;

        const $src = this.$srcs[index];
        const rec = $src.getBoundingClientRect();

        return { w:Math.round(rec.width), h:Math.round(rec.height) };
    }
}